export enum WalletVerificationStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Important = 'IMPORTANT',
  Success = 'SUCCESS'
}


// WEBPACK FOOTER //
// ./src/model/types/wallet-verification-status.ts